import type { EventName } from "@lit/react";
import { Accordion as AccordionElement, type AccordionEventMap as _AccordionEventMap, } from "@vaadin/accordion/vaadin-accordion.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { AccordionElement, };
export type AccordionEventMap = Readonly<{
    onItemsChanged: EventName<_AccordionEventMap["items-changed"]>;
    onOpenedChanged: EventName<_AccordionEventMap["opened-changed"]>;
}>;
const events = { onItemsChanged: "items-changed", onOpenedChanged: "opened-changed" } as AccordionEventMap;
export type AccordionProps = WebComponentProps<AccordionElement, AccordionEventMap>;
export const Accordion = createComponent({
    elementClass: AccordionElement, events, react: React, tagName: "vaadin-accordion"
});
